import { HttpService } from './../../../wrappers/Http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { EndPoints } from 'src/app/configs';

@Injectable({
  providedIn: 'root'
})
export class SportServiceService {

  cancelledMarkets: any = {};
  matchStatistics: any = {};
  activeTournaments: Array<any> = [];
  activeGroup: Array<any> = [];
  latestWinners: Array<any> = [];
  private _gratuits: any = [];
  publications: any[];
  publicationCounts: any;


  constructor(public requestHandler: HttpService, private configService: ConfigService) { }

  public get gratuits(): any {
    return this._gratuits;
  }
  public set gratuits(value: any) {
    this._gratuits = value;
  }
  loadPublication(params: any = {}, more = ''){
    params.status = true;
    params.time = new Date().getTime()
    return this.requestHandler.Hget(this.configService.PROXIES.userService, EndPoints.publication  , params).then(response => {
      if (more === 'load-more') {
        // this.publications  = [...this.publications, ...response.data];
        this.publications.push(response.data)
        this.publicationCounts = response.count;
      } else {
        this.publications = response.data;
        this.publicationCounts = response.count;
      }

  });
  }
  marketInList(market: any, markets: Array<any>) {
    return markets ? markets.filter(element => {
      return element.id === market.specifier ? market.id + "*" + market.specifier : market.id;
    }).length > 0 : false;
  }
}
